import { DateTime } from "luxon";
export const dayOffDates = value => [...new Set((Array.isArray(value) ? value : Object.values(value || {})).filter(date=>typeof date==="string"))].sort();
export function weekdayDaysOff(value,year,today) {
  const dates=dayOffDates(value).filter(date=>{
    const parsed=DateTime.fromISO(date,{zone:"America/New_York"});
    return /^\d{4}-\d{2}-\d{2}$/.test(date) && parsed.isValid && parsed.year===Number(year) && parsed.weekday<=5;
  });
  return {taken:dates.filter(date=>date<=today).length,upcoming:dates.filter(date=>date>today).length,total:dates.length};
}
export async function deleteSelectedDaysOff(selected,{db,doc,runTransaction}) {
  const grouped=new Map();
  selected.forEach(({staffId,date})=>{if(!grouped.has(staffId))grouped.set(staffId,new Set());grouped.get(staffId).add(date);});
  if(!grouped.size || grouped.size>100)throw new Error("Select requests for between 1 and 100 staff members.");
  return runTransaction(db,async transaction=>{
    const entries=[...grouped].map(([staffId,dates])=>({staffId,dates,reference:doc(db,"staff_day_off",staffId)}));
    const snapshots=await Promise.all(entries.map(entry=>transaction.get(entry.reference)));
    return entries.map((entry,index)=>{
      if(!snapshots[index].exists())return {staffId:entry.staffId,dates:[]};
      const dates=dayOffDates(snapshots[index].data().dayOffRequests).filter(date=>!entry.dates.has(date));
      const dayOffTypes=Object.fromEntries(Object.entries(snapshots[index].data().dayOffTypes || {}).filter(([date])=>dates.includes(date)));
      transaction.update(entry.reference,{dayOffRequests:dates,dayOffTypes});
      return {staffId:entry.staffId,dates,dayOffTypes};
    });
  });
}

export const canManageDayOff = user => user?.isSuperAdmin === true && ["rob@vsnmichigan.com","case@vsnmichigan.com"].includes(String(user.email || "").trim().toLowerCase());
export async function migrateStaffDaysOff(staffId,{db,doc,runTransaction,deleteField}) {
  return runTransaction(db,async transaction=>{
    const staffRef=doc(db,"staff",staffId),privateRef=doc(db,"staff_day_off",staffId);
    const [staff,privateRecord]=await Promise.all([transaction.get(staffRef),transaction.get(privateRef)]);
    if(!staff.exists())return null;
    const data=staff.data(),previous=privateRecord.exists()?privateRecord.data():{};
    const hasLegacy=Object.prototype.hasOwnProperty.call(data,"dayOffRequests");
    const profile={email:String(data.email || "").trim().toLowerCase(),nickname:data.nickname || "",name:data.name || ""};
    const dates=dayOffDates([...dayOffDates(previous.dayOffRequests),...(hasLegacy?dayOffDates(data.dayOffRequests):[])]);
    if(!privateRecord.exists() || hasLegacy || Object.entries(profile).some(([key,value])=>previous[key]!==value))transaction.set(privateRef,{...previous,...profile,dayOffRequests:dates});
    if(hasLegacy)transaction.update(staffRef,{dayOffRequests:deleteField()});
    return {...profile,id:staffId,dayOffRequests:dates};
  });
}

export function findOwnDayOffStaff(records,email) {
  const normalized=String(email || "").trim().toLowerCase();
  if(!normalized)throw new Error("Your login has no email address. Contact Rob or Case.");
  const matches=records.filter(record=>String(record.email || "").trim().toLowerCase()===normalized);
  if(matches.length>1)throw new Error("More than one staff record matches your email. Contact Rob or Case to correct the records.");
  return matches[0] || null;
}

export const DAY_OFF_TYPES = {general:"Other / unclassified",vacation:"Vacation",sick:"Sick"};
export function dayOffType(staff,date) {
  const type=staff.dayOffTypes?.[date];
  return Object.prototype.hasOwnProperty.call(DAY_OFF_TYPES,type) ? type : "general";
}
export function dayOffTypeTotals(staff,year,today) {
  return Object.keys(DAY_OFF_TYPES).map(type=>({type,label:DAY_OFF_TYPES[type],...weekdayDaysOff(dayOffDates(staff.dayOffRequests).filter(date=>dayOffType(staff,date)===type),year,today)}));
}
export async function saveDayOffDates(staffId,dates,type,{db,doc,runTransaction},reclassify=false) {
  if(!Object.prototype.hasOwnProperty.call(DAY_OFF_TYPES,type))throw new Error("Choose a valid day-off type.");
  return runTransaction(db,async transaction=>{
    const reference=doc(db,"staff_day_off",staffId),snapshot=await transaction.get(reference);
    if(!snapshot.exists())throw new Error("Staff record no longer exists.");
    const previous=dayOffDates(snapshot.data().dayOffRequests);
    const next=reclassify ? previous : dayOffDates([...previous,...dates]);
    const dayOffTypes=Object.fromEntries(next.map(date=>[date,dayOffType(snapshot.data(),date)]));
    dates.forEach(date=>{if(next.includes(date) && (reclassify || !previous.includes(date)))dayOffTypes[date]=type;});
    transaction.update(reference,{dayOffRequests:next,dayOffTypes});
    return {staffId,dates:next,dayOffTypes};
  });
}
